import { useMutation } from '@tanstack/react-query'

import { depositGuaranteeMoneyBalance } from '@src/api'
import { DefaultApiDepositGuaranteeMoneyBalanceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDepositGuaranteeMoneyBalance = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDepositGuaranteeMoneyBalanceRequest) =>
      depositGuaranteeMoneyBalance(axiosInstance, params),
  })
}
